import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=06d55a2c"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"
import style0 from "./TheHeader.vue?vue&type=style&index=0&id=06d55a2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports